import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { ReactComponent as Pattern } from "./pattern.svg";
import { zIndexes } from "../../styles/theme";

export default function EntainPattern() {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isXLarge = useMediaQuery(theme.breakpoints.up("xl"));
  const [patternPosition, setPatternPosition] = React.useState({ right: 0, top: 0 });
  const [patternDisplay, setPatternDisplay] = React.useState("block");

  React.useEffect(() => {
    if (isLarge) setPatternPosition({ right: -100, top: 0 });
    if (isLarge && isXLarge) setPatternPosition({ right: 0, top: 0 });
    if (!isLarge && !isXLarge) setPatternDisplay("none");
    if (isLarge || isXLarge) setPatternDisplay("block");
  }, [isLarge, isXLarge]);

  return (
    <>
      <Pattern
        style={{
          position: "fixed",
          ...patternPosition,
          zIndex: zIndexes.Bottom,
          top: 67, // height of header
          transform: "rotateY(180deg)",
          display: patternDisplay,
        }}
      />
      <Pattern
        style={{
          position: "fixed",
          ...patternPosition,
          zIndex: zIndexes.Bottom,
          top: 67 + 1080, // height of header + pattern
          transform: "rotateY(180deg) rotateX(180deg)",
          display: patternDisplay,
        }}
      />
    </>
  );
}
